import { render, staticRenderFns } from "./TotalPacientes.vue?vue&type=template&id=75a55a38&scoped=true"
import script from "./TotalPacientes.vue?vue&type=script&lang=js"
export * from "./TotalPacientes.vue?vue&type=script&lang=js"
import style0 from "./TotalPacientes.vue?vue&type=style&index=0&id=75a55a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a55a38",
  null
  
)

export default component.exports